<template>
  <v-dialog
    v-model="isModalOpened"
    max-width="610px"
    @click:outside="closeModal"
  >
    <v-card>
      <v-row class="ma-0">
        <v-col cols="10" class="d-flex align-center">
          <h1> {{ titleType }} </h1>
        </v-col>
        <v-col cols="2" class="d-flex justify-end">
          <v-btn
            class="px-0"
            @click="closeModal"
            fab
            text
            height="auto"
          >
            <v-icon large>mdi-close</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" v-html="context" class="text-center text-16">
        </v-col>
        <v-col cols="12" class="d-flex justify-end pt-2">
          <v-btn
            dark
            color="#ACC3CF"
            @click="submitModal"
            v-if="titleType === 'Confirmation Required'"
          >
            {{ buttonText }}
          </v-btn>
          <v-btn
              dark
              color="#ACC3CF"
              @click="closeModal"
              v-else
          >
            {{ buttonText }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    titleType: {
      type: String,
      default: ''
    },
    context: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    isModalOpened: {
      type: Boolean,
      default: false
    },
  },
  name: "ValidationAlert",
  data() {
    return {

    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    submitModal() {
      this.$emit('submit')
    }
  }
}
</script>

<style lang="sass">
.highlighted-text
  color: var(--v-primary-base)

.warning-highlight
  color: #ff0000
</style>